import { render, staticRenderFns } from "./PeerGroupMemberActionsMenu.vue?vue&type=template&id=8c71cb5e&"
import script from "./PeerGroupMemberActionsMenu.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupMemberActionsMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports